const LogoutPage = () => {
  const handleLogin = () => {
    window.location.href = '/';
  };

  return (
    <div className="logout-page">
      <div className="logout-page__card">
        <h2 className="logout-page__title">You have been logged out</h2>
        <p className="logout-page__message">Your session has ended.</p>
        <button className="logout-page__login-btn" onClick={handleLogin}>
          Log in again
        </button>
      </div>
    </div>
  );
};

export default LogoutPage;
